




















import { Prop, Watch } from "vue-property-decorator";
import ComponentVue from "@/app/core/window/ComponentVue";
import { Component, Mixins } from "vue-mixin-decorator";
import ChatColorTypeSelect from "@/app/basic/common/components/select/ChatColorTypeSelect.vue";
import ColorPickerComponent from "@/app/core/component/ColorPickerComponent.vue";

@Component({ components: { ColorPickerComponent, ChatColorTypeSelect } })
export default class TrChatColorInputComponent extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: String, required: true })
  private labelName!: string;

  @Prop({ type: Boolean, default: false })
  private disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  private readonly!: boolean;

  // type
  @Prop({ type: String, required: true })
  private type!: string;
  private typeVolatile: string = "owner";
  @Watch("type", { immediate: true })
  private onChangeType(value: string) {
    this.typeVolatile = value;
  }
  @Watch("typeVolatile")
  private onChangeTypeVolatile(value: string) {
    this.$emit("update:type", value);
  }

  // color
  @Prop({ type: String, required: true })
  private color!: string;
  private colorVolatile: string = "#000000";
  @Watch("color", { immediate: true })
  private onChangeColor(value: string) {
    this.colorVolatile = value;
  }
  @Watch("colorVolatile")
  private onChangeColorVolatile(value: string) {
    this.$emit("update:color", value);
  }
}
